<template>
  <section class="py-4 pb-5 contact-section">
    <div class="container">

      <h2 class="mb-2 text-center display-6 fw-bold text-primary animate__animated animate__fadeInDown">
        <i class="fas fa-envelope-open-text me-2"></i> Contactează-ne
      </h2>
      <p class="text-center lead text-muted mb-4 mx-auto contact-subtitle animate__animated animate__fadeInDown animate__delay-1s">
        Scrie-ne sau trimite o cerere și te contactăm în cel mai scurt timp.
      </p>

      <!-- Contact info cards -->
      <div class="row g-3 mb-4 justify-content-center">
        <div class="col-12 col-sm-4">
          <div class="contact-info-card d-flex align-items-center gap-3 p-3 rounded-4 bg-white shadow-sm h-100">
            <div class="contact-icon-wrap flex-shrink-0">
              <i class="fas fa-phone text-primary"></i>
            </div>
            <div>
              <div class="small text-muted">Telefon</div>
              <a href="tel:+40766718238" class="fw-semibold text-dark text-decoration-none contact-link">+40 766 718 238</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <div class="contact-info-card d-flex align-items-center gap-3 p-3 rounded-4 bg-white shadow-sm h-100">
            <div class="contact-icon-wrap flex-shrink-0">
              <i class="fas fa-envelope text-primary"></i>
            </div>
            <div class="overflow-hidden">
              <div class="small text-muted">Email</div>
              <a href="mailto:achizitiiprofesionale@gmail.com" class="fw-semibold text-dark text-decoration-none contact-link text-truncate d-block">achizitiiprofesionale@gmail.com</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <div class="contact-info-card d-flex align-items-center gap-3 p-3 rounded-4 bg-white shadow-sm h-100">
            <div class="contact-icon-wrap flex-shrink-0">
              <i class="fas fa-map-marker-alt text-primary"></i>
            </div>
            <div>
              <div class="small text-muted">Adresă</div>
              <span class="fw-semibold text-dark small">Calea Apeductului 13, București</span>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA -->
      <div class="text-center mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <router-link to="/contact" class="btn btn-primary btn-lg px-5">
          <i class="fas fa-paper-plane me-2"></i> Trimite o cerere de consultanță
        </router-link>
      </div>

      <!-- Map -->
      <div class="map-container rounded-4 overflow-hidden shadow animate__animated animate__fadeIn animate__delay-3s">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.4131712406386!2d26.10252861553481!3d44.426767079102846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff5e6c7b3c29%3A0x4c1a5912b8e60b82!2sPalatul%20Parlamentului!5e0!3m2!1sro!2sro!4v1680000000000"
          width="100%"
          height="300"
          style="border:0; display:block;"
          allowfullscreen="false"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

    </div>
  </section>
</template>

<style scoped>
.contact-section {
  background: linear-gradient(180deg, #ffffff 0%, #f4f7fb 100%);
}

.contact-subtitle {
  max-width: 520px;
  font-size: 0.97rem;
}

.contact-info-card {
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
}
.contact-info-card:hover {
  transform: translateY(-2px);
}

.contact-icon-wrap {
  width: 42px;
  height: 42px;
  background: rgba(13, 110, 253, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.contact-link {
  font-size: 0.9rem;
}

.map-container {
  max-width: 900px;
  margin: 0 auto;
}

@media (max-width: 576px) {
  .map-container iframe {
    height: 220px;
  }
  .btn-lg {
    font-size: 0.95rem;
    padding: 0.6rem 1.5rem;
  }
}
</style>